
































































import Vue from 'vue';
import money from 'v-money';
import {AxiosResponse} from 'axios';
import {ServerData} from '@/struct/Axios';
import {FormData} from '@/struct/Form';
import {alphaNum, decimal, maxLength, maxValue, minLength, minValue, required} from 'vuelidate/lib/validators';

Vue.use(money, {precision: 2});

export default Vue.extend({
    name: 'Betaalverzoek' as string,
    props: {
        tranction_url: String,
        dw_organization_id: String
    },
    data() {
        return {
            amount: null,
            description: '',
            paymentKey: '',
            isValid: false,
            showLoginNotification: false,
            errorMessage: '',
            formData: {
                amount: null as number | null,
                description: '' as string
            } as FormData,
            fields: ['amount', 'description']
        };
    },
    validations: {
        amount: {
            required,
            decimal,
            minValue: minValue(0.5),
            maxValue: maxValue(10000),
        },
        description: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(50),
            alphaNum: alphaNum()
        },
    },
    computed: {
        whatsappMessage(): string {
            return 'Wil je me € ' + (this.formData.amount / 100).toFixed(2) + ' betalen voor ' + this.formData.description + '?  https%3A%2F%2Fwww.e-acceptgiro.nl%2Fpay%2F' + this.paymentKey;
        },
    },
    methods: {
        // cleanDecimal(): void {
        //     if (this.amount) {
        //         this.amount = this.amount.replace('.', ',');
        //     }
        //     if (this.$v && this.$v.amount) {
        //         this.$v.amount.$touch();
        //     }
        // },
        validate(): boolean {
            this.$v.$touch();
            let isValid = true;

            this.fields.forEach((field) => {
                this.formData[field] = this[field];
                if (this.$v[field].$invalid) {
                    isValid = false;
                }
            });

            return isValid;
        },

        createTransaction() {
            this.isValid = this.validate();
            if (this.dw_organization_id.length === 0) {
                this.showLoginNotification = true;
            } else {
                if (this.isValid) {

                    const formDataSerialized: FormData = this.formData;
                    formDataSerialized.amount = formDataSerialized.amount * 100;
                    (this as any).$http
                        .post(this.tranction_url, formDataSerialized)
                        .then((request: AxiosResponse<ServerData>) =>
                            this.parseCreateResponse(request)
                        )
                        .catch((e: any) => this.requestFailed(e));
                }
            }
        },

        parseCreateResponse(response: AxiosResponse<ServerData>) {
            if (response.status !== 200) {
                this.requestFailed(response);
                return false;
            }
            if (typeof response.data === 'object') {
                this.paymentKey = response.data.key;
            }
        },

        requestFailed(e: any) {
            this.errorMessage = 'Ik heb helaas een verkeerd antwoord van de server ontvangen: ' + e;
        }
    }
});
